<ngx-ui-loader [fgsType]="spinnerType" logoSize="120" logoUrl="./assets/images/logo-80_white.svg">
</ngx-ui-loader>
<router-outlet></router-outlet>